/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MarketingRouteImport } from './routes/_marketing'
import { Route as MarketingIndexRouteImport } from './routes/_marketing/index'
import { Route as MarketingTermsRouteImport } from './routes/_marketing/terms'
import { Route as MarketingSupportRouteImport } from './routes/_marketing/support'
import { Route as MarketingSelfHostRouteImport } from './routes/_marketing/self-host'
import { Route as MarketingSecurityRouteImport } from './routes/_marketing/security'
import { Route as MarketingPrivacyRouteImport } from './routes/_marketing/privacy'
import { Route as MarketingPricingRouteImport } from './routes/_marketing/pricing'
import { Route as MarketingOpentelemetryRouteImport } from './routes/_marketing/opentelemetry'
import { Route as MarketingHowItWorksRouteImport } from './routes/_marketing/how-it-works'
import { Route as MarketingFeaturesRouteImport } from './routes/_marketing/features'
import { Route as MarketingDpaRouteImport } from './routes/_marketing/dpa'
import { Route as MarketingCliRouteImport } from './routes/_marketing/cli'
import { Route as MarketingArchitectureRouteImport } from './routes/_marketing/architecture'

const MarketingRoute = MarketingRouteImport.update({
  id: '/_marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingIndexRoute = MarketingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingTermsRoute = MarketingTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingSupportRoute = MarketingSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingSelfHostRoute = MarketingSelfHostRouteImport.update({
  id: '/self-host',
  path: '/self-host',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingSecurityRoute = MarketingSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingPrivacyRoute = MarketingPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingPricingRoute = MarketingPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingOpentelemetryRoute = MarketingOpentelemetryRouteImport.update({
  id: '/opentelemetry',
  path: '/opentelemetry',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingHowItWorksRoute = MarketingHowItWorksRouteImport.update({
  id: '/how-it-works',
  path: '/how-it-works',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingFeaturesRoute = MarketingFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingDpaRoute = MarketingDpaRouteImport.update({
  id: '/dpa',
  path: '/dpa',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingCliRoute = MarketingCliRouteImport.update({
  id: '/cli',
  path: '/cli',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingArchitectureRoute = MarketingArchitectureRouteImport.update({
  id: '/architecture',
  path: '/architecture',
  getParentRoute: () => MarketingRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof MarketingIndexRoute
  '/architecture': typeof MarketingArchitectureRoute
  '/cli': typeof MarketingCliRoute
  '/dpa': typeof MarketingDpaRoute
  '/features': typeof MarketingFeaturesRoute
  '/how-it-works': typeof MarketingHowItWorksRoute
  '/opentelemetry': typeof MarketingOpentelemetryRoute
  '/pricing': typeof MarketingPricingRoute
  '/privacy': typeof MarketingPrivacyRoute
  '/security': typeof MarketingSecurityRoute
  '/self-host': typeof MarketingSelfHostRoute
  '/support': typeof MarketingSupportRoute
  '/terms': typeof MarketingTermsRoute
}
export interface FileRoutesByTo {
  '/architecture': typeof MarketingArchitectureRoute
  '/cli': typeof MarketingCliRoute
  '/dpa': typeof MarketingDpaRoute
  '/features': typeof MarketingFeaturesRoute
  '/how-it-works': typeof MarketingHowItWorksRoute
  '/opentelemetry': typeof MarketingOpentelemetryRoute
  '/pricing': typeof MarketingPricingRoute
  '/privacy': typeof MarketingPrivacyRoute
  '/security': typeof MarketingSecurityRoute
  '/self-host': typeof MarketingSelfHostRoute
  '/support': typeof MarketingSupportRoute
  '/terms': typeof MarketingTermsRoute
  '/': typeof MarketingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_marketing': typeof MarketingRouteWithChildren
  '/_marketing/architecture': typeof MarketingArchitectureRoute
  '/_marketing/cli': typeof MarketingCliRoute
  '/_marketing/dpa': typeof MarketingDpaRoute
  '/_marketing/features': typeof MarketingFeaturesRoute
  '/_marketing/how-it-works': typeof MarketingHowItWorksRoute
  '/_marketing/opentelemetry': typeof MarketingOpentelemetryRoute
  '/_marketing/pricing': typeof MarketingPricingRoute
  '/_marketing/privacy': typeof MarketingPrivacyRoute
  '/_marketing/security': typeof MarketingSecurityRoute
  '/_marketing/self-host': typeof MarketingSelfHostRoute
  '/_marketing/support': typeof MarketingSupportRoute
  '/_marketing/terms': typeof MarketingTermsRoute
  '/_marketing/': typeof MarketingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/architecture'
    | '/cli'
    | '/dpa'
    | '/features'
    | '/how-it-works'
    | '/opentelemetry'
    | '/pricing'
    | '/privacy'
    | '/security'
    | '/self-host'
    | '/support'
    | '/terms'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/architecture'
    | '/cli'
    | '/dpa'
    | '/features'
    | '/how-it-works'
    | '/opentelemetry'
    | '/pricing'
    | '/privacy'
    | '/security'
    | '/self-host'
    | '/support'
    | '/terms'
    | '/'
  id:
    | '__root__'
    | '/_marketing'
    | '/_marketing/architecture'
    | '/_marketing/cli'
    | '/_marketing/dpa'
    | '/_marketing/features'
    | '/_marketing/how-it-works'
    | '/_marketing/opentelemetry'
    | '/_marketing/pricing'
    | '/_marketing/privacy'
    | '/_marketing/security'
    | '/_marketing/self-host'
    | '/_marketing/support'
    | '/_marketing/terms'
    | '/_marketing/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  MarketingRoute: typeof MarketingRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_marketing': {
      id: '/_marketing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_marketing/': {
      id: '/_marketing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MarketingIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/terms': {
      id: '/_marketing/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof MarketingTermsRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/support': {
      id: '/_marketing/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof MarketingSupportRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/self-host': {
      id: '/_marketing/self-host'
      path: '/self-host'
      fullPath: '/self-host'
      preLoaderRoute: typeof MarketingSelfHostRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/security': {
      id: '/_marketing/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof MarketingSecurityRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/privacy': {
      id: '/_marketing/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof MarketingPrivacyRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/pricing': {
      id: '/_marketing/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof MarketingPricingRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/opentelemetry': {
      id: '/_marketing/opentelemetry'
      path: '/opentelemetry'
      fullPath: '/opentelemetry'
      preLoaderRoute: typeof MarketingOpentelemetryRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/how-it-works': {
      id: '/_marketing/how-it-works'
      path: '/how-it-works'
      fullPath: '/how-it-works'
      preLoaderRoute: typeof MarketingHowItWorksRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/features': {
      id: '/_marketing/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof MarketingFeaturesRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/dpa': {
      id: '/_marketing/dpa'
      path: '/dpa'
      fullPath: '/dpa'
      preLoaderRoute: typeof MarketingDpaRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/cli': {
      id: '/_marketing/cli'
      path: '/cli'
      fullPath: '/cli'
      preLoaderRoute: typeof MarketingCliRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/architecture': {
      id: '/_marketing/architecture'
      path: '/architecture'
      fullPath: '/architecture'
      preLoaderRoute: typeof MarketingArchitectureRouteImport
      parentRoute: typeof MarketingRoute
    }
  }
}

interface MarketingRouteChildren {
  MarketingArchitectureRoute: typeof MarketingArchitectureRoute
  MarketingCliRoute: typeof MarketingCliRoute
  MarketingDpaRoute: typeof MarketingDpaRoute
  MarketingFeaturesRoute: typeof MarketingFeaturesRoute
  MarketingHowItWorksRoute: typeof MarketingHowItWorksRoute
  MarketingOpentelemetryRoute: typeof MarketingOpentelemetryRoute
  MarketingPricingRoute: typeof MarketingPricingRoute
  MarketingPrivacyRoute: typeof MarketingPrivacyRoute
  MarketingSecurityRoute: typeof MarketingSecurityRoute
  MarketingSelfHostRoute: typeof MarketingSelfHostRoute
  MarketingSupportRoute: typeof MarketingSupportRoute
  MarketingTermsRoute: typeof MarketingTermsRoute
  MarketingIndexRoute: typeof MarketingIndexRoute
}

const MarketingRouteChildren: MarketingRouteChildren = {
  MarketingArchitectureRoute: MarketingArchitectureRoute,
  MarketingCliRoute: MarketingCliRoute,
  MarketingDpaRoute: MarketingDpaRoute,
  MarketingFeaturesRoute: MarketingFeaturesRoute,
  MarketingHowItWorksRoute: MarketingHowItWorksRoute,
  MarketingOpentelemetryRoute: MarketingOpentelemetryRoute,
  MarketingPricingRoute: MarketingPricingRoute,
  MarketingPrivacyRoute: MarketingPrivacyRoute,
  MarketingSecurityRoute: MarketingSecurityRoute,
  MarketingSelfHostRoute: MarketingSelfHostRoute,
  MarketingSupportRoute: MarketingSupportRoute,
  MarketingTermsRoute: MarketingTermsRoute,
  MarketingIndexRoute: MarketingIndexRoute,
}

const MarketingRouteWithChildren = MarketingRoute._addFileChildren(
  MarketingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  MarketingRoute: MarketingRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
